import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import { Size } from '../../constants.js';
import { useId } from '../../utils/hooks/useId.js';
import './Input.scss.js';

const bem = Bem.create("vai-input");
const bemAdornment = Bem.create("vai-adornment");
const Input = React.forwardRef(function PasswordInput(props, ref) {
  const {
    htmlId,
    invalid,
    dataTa = "vai-input",
    width = Size.M,
    type = "text",
    readOnly = false,
    autoComplete,
    name,
    spellCheck,
    onChange,
    innerRef,
    inputProps,
    className,
    disabled,
    value,
    onFocus,
    onBlur,
    endIcon,
    unitLabel,
    wrapperChildren,
    ...rest
  } = props;
  const [focus, setFocus] = React.useState(false);
  const id = useId(htmlId, ["container"]);
  const inputId = id.copyWith(["input"]).toString();
  const idAdornment = id.copyWith(["adornment"]).toString();
  const handleFocus = (e) => {
    setFocus(true);
    if (onFocus) {
      onFocus(e);
    }
  };
  const handleBlur = (e) => {
    setFocus(false);
    if (onBlur) {
      onBlur(e);
    }
  };
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(focus && "focused", disabled && "disabled", width), className),
    ref,
    ...rest
  }, /* @__PURE__ */ React.createElement("div", {
    "data-ta": `${dataTa}--wrapper`,
    className: bem.element("wrapper")(focus && "focused", disabled && "disabled", invalid && "invalid", width)
  }, /* @__PURE__ */ React.createElement("input", {
    id: inputId,
    "data-ta": `${dataTa}--input`,
    className: bem.element("input")(invalid && "invalid"),
    name,
    ref: innerRef,
    type,
    disabled,
    value,
    onFocus: handleFocus,
    onBlur: handleBlur,
    readOnly,
    onChange,
    autoComplete,
    spellCheck,
    autoCapitalize: "off",
    ...inputProps
  }), /* @__PURE__ */ React.createElement("div", {
    "data-ta": `${dataTa}--adornment`,
    id: idAdornment,
    className: bemAdornment.block(disabled && "disabled")
  }, endIcon), wrapperChildren ? wrapperChildren : null), unitLabel && /* @__PURE__ */ React.createElement("span", {
    "data-ta": `${dataTa}--unit-label`,
    className: bem.element("unit-label")()
  }, unitLabel));
});
Input.metaProperties = ["invalid", "disabled"];

export { Input };
